export default "__VITE_ASSET__DbdP6KB5__"